import { commonTypes } from "../common";

export const types = {
  SET_SUMMARY_CHECKBOXES_VALUE: 'UINEEDS/SET_SUMMARY_CHECKBOXES_VALUE',
  SET_PRICES_DISCREPANCY: 'UINEEDS/SET_PRICES_DISCREPANCY',
  SET_DOWNGRADES_BY_INCOMPATIBILITY: 'UINEEDS/SET_DOWNGRADES_BY_INCOMPATIBILITY',
  SET_R2R_PRICE_CHANGE: 'UINEEDS/SET_R2R_PRICE_CHANGE',
};

export const initialState = {
  summaryCheckboxes: {
    advertisingUse: false,
    fundingLegal: false,
    legalTerms: false,
  },
  hasPriceDiscrepancy: false,
  downgradesByIncompatibility: null,
  r2rPriceChanged: null,
};

const UINeedsSummaryReducer = (state, action) => {
  switch (action.type) {
    case types.SET_SUMMARY_CHECKBOXES_VALUE: {
      const {
        legalTerms,
        advertisingUse,
        fundingLegal,
      } = action.payload;

      if (typeof legalTerms !== 'undefined') {
        const newState = {
          ...state,
          summaryCheckboxes: {
            ...state.summaryCheckboxes,
            legalTerms,
          },
        };

        return {
          state: newState,
          stepsMustBeEvaluated: false,
        };
      }

      if (typeof advertisingUse !== 'undefined') {
        const newState = {
          ...state,
          summaryCheckboxes: {
            ...state.summaryCheckboxes,
            advertisingUse,
          },
        };

        return {
          state: newState,
          stepsMustBeEvaluated: false,
        };
      }

      if (typeof fundingLegal !== 'undefined') {
        const newState = {
          ...state,
          summaryCheckboxes: {
            ...state.summaryCheckboxes,
            fundingLegal,
          },
        };

        return {
          state: newState,
          stepsMustBeEvaluated: false,
        };
      }

      return null;
    }
    case types.SET_PRICES_DISCREPANCY: {
      const {
        hasPriceDiscrepancy,
      } = action.payload;

      const newState = {
        ...state,
        hasPriceDiscrepancy,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SET_DOWNGRADES_BY_INCOMPATIBILITY: {
      const {
        downgradesByIncompatibility,
      } = action.payload;

      const newState = {
        ...state,
        downgradesByIncompatibility,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SET_R2R_PRICE_CHANGE: {
      const {
        r2rPriceChanged,
      } = action.payload;

      const newState = {
        ...state,
        r2rPriceChanged,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case commonTypes.SET_POSHT_SELECTED: {
      const { poshtSelected } = action.payload;
      const newState = {
        ...state,
        poshtSelected,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setSummaryCheckboxesValue: info => ({
    type: types.SET_SUMMARY_CHECKBOXES_VALUE,
    payload: {
      ...info,
    },
  }),
  setPricesDiscrepancy: hasPriceDiscrepancy => ({
    type: types.SET_PRICES_DISCREPANCY,
    payload: {
      hasPriceDiscrepancy,
    },
  }),
  setDowngradesByIncompatibility: downgradesByIncompatibility => ({
    type: types.SET_DOWNGRADES_BY_INCOMPATIBILITY,
    payload: {
      downgradesByIncompatibility,
    },
  }),
  setR2RPriceChange: r2rPriceChanged => ({
    type: types.SET_R2R_PRICE_CHANGE,
    payload: {
      r2rPriceChanged,
    },
  }),
};

export default UINeedsSummaryReducer;
